import formatDate from "../dateHelper";
import { getBrowserFingerprintData } from "./browserFingerprint";
import { getGeolocationData } from "./geolocation"; // Fixed import


export const getRequestBaseData = async (pageType=null) => {
    let baseData = { requestSource: "Web" };

    try {
        const geoData = await getGeolocationData();
        if (geoData?.coords) {
            baseData.reqLong = geoData.coords.longitude.toFixed(6).toString();
            baseData.reqLat = geoData.coords.latitude.toFixed(6).toString();
        }
        
    } catch (e) {
        console.warn("Unable to fetch geolocation data:", e);
    }

    baseData.localTimeStamp = formatDate(new Date());

    if(localStorage.getItem('commDeviceId')){
        baseData.commDeviceId = localStorage.getItem('commDeviceId');
    }else{
        const fingerprint = await getBrowserFingerprintData();
        if (fingerprint){
            baseData.commDeviceId = fingerprint.toString();
            localStorage.setItem('commDeviceId',fingerprint.toString());
        } 
    }
    
if (localStorage.getItem("requestIp")) {
  baseData.requestIp = localStorage.getItem("requestIp");
} else {
    try {
        const ipData = await fetch("https://api.ipify.org?format=json")
            .then(res => res.json());
        if (ipData?.ip) {
            baseData.requestIp = ipData.ip;
            localStorage.setItem("requestIp", ipData.ip);
        }
    } catch (e) {
        console.warn("Unable to fetch IP address:", e);
    }
}

    baseData.version = "1.0";
    baseData.appName = "INSURANCE_X";
    baseData.scope = "SESSION_INIT";
    

    return baseData;
};
